class DocumentationPathMonoData {

    constructor() {
        this.monoDocument = null;
    }

    getData() {
        return this.monoDocument;
    }

    setData(monoDocument) {
        this.monoDocument = monoDocument;
    }

}